// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__O7R-v","options":"AnswerScale_options__tbMEv","selected":"AnswerScale_selected__1gIKb"};